import { TalentAdjustedTimeSheet } from 'src/types/resources/TimeSheet';
import { ListResponse } from 'src/types/utils';
import apiRoutes from 'src/routes/apiRoutes';
import Fetcher from 'src/utils/fetcher';

export type IndexParams = {
  timekeepingDate?: string;
  enteredAt?: string;
  ordering?: string;
  page?: number;
};

export default {
  index(params: IndexParams): Promise<ListResponse<TalentAdjustedTimeSheet>> {
    const url = apiRoutes.talent.timeSheetsAdjustmentsPath();
    return Fetcher.get(url, params);
  },
};
